import script from "./PayoutsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayoutsPage.vue?vue&type=script&setup=true&lang=ts"

import "./PayoutsPage.vue?vue&type=style&index=0&id=2b4a7c8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b4a7c8e"]])

export default __exports__